import { ActionTypes } from '../constants';
import { OptionTypes, DefaultRootAreas } from '../constants';

const initialAreas = () => {
  const list = [];
  const areaIds = [];
  let rootAreaId = Object.keys(window.initialPoint).length ? window.initialPoint.root : DefaultRootAreas[0].id;
  let houseTypeId = OptionTypes.HOUSE_NONE;
  if (
    'initialOptions' in window &&
    'selected' in window.initialOptions &&
    'areas' in window.initialOptions.selected
  ) {
    houseTypeId = window.initialOptions.selected.houseTypeId;

    window.initialOptions.selected.areas.forEach(a => {
      let maxNum = 0;
      rootAreaId = Number(a.rootId);

      switch (window.initialOptions.selected.houseTypeId) {
        case OptionTypes.HOUSE_SINGLE:
          maxNum = Number(a.single);
          break;
        case OptionTypes.HOUSE_COMPLEX:
          maxNum = Number(a.complex);
          break;
        case OptionTypes.HOUSE_NONE:
        default:
          maxNum = Number(a.sum);
          break;
      }
      const area = {
        rootId: Number(a.rootId),
        grandparent_id: Number(a.grandparent_id),
        parent_id: Number(a.parent_id),
        level: Number(a.level),
        id: Number(a.id),
        name: a.name,
        short_name: a.short_name,
        parent_name: a.parent_name,
        single: Number(a.single),
        complex: Number(a.complex),
        sum: Number(a.sum),
        num: Number(a.num),
        maxNum: maxNum,
        error: ''
      };
      list.push(area);
      areaIds.push(Number(a.id));
    });
  }

  const areas = {
    list: list,
    areaIds: areaIds,
    houseTypeId: houseTypeId,
    sumNum: 0,
    sumMaxNum: 0,
    rootAreaId: rootAreaId,
		openResetDialog: false,
    errors: {}
  };
  setSumNums(areas);
  return areas;
};
// listのサンプル↓
// list[0] = {
//     rootId: addAreaで設定
//     level: 1-3,
//     id: areaId,
//     name: name,
//     single: single,
//     complex: complex,
//     sum: sum,
//     num: sum,
//     maxNum: sum,
//     error: '',
// }

function setSumNums(areas) {
  var sumNum = 0;
  var sumMaxNum = 0;
  areas.list.forEach(area => {
    sumNum += parseInt(area.num, 10);
    sumMaxNum += parseInt(area.maxNum, 10);
  });
  areas.sumNum = sumNum;
  areas.sumMaxNum = sumMaxNum;
}

// Reducer
function areasReducer(areas = initialAreas(), action) {
  switch (action.type) {
    case ActionTypes.ADD_AREA_TO_LIST:
      areas.list = action.list.sort((a,b)=>{
				return (a.name === b.name ? 0 : a.name < b.name ? -1 : 1);
			});
      areas.areaIds = action.list.map((a)=>(a.id));
      setSumNums(areas);
      return { ...areas };

    case ActionTypes.REMOVE_AREA_FROM_LIST:
      const remove_key = areas.areaIds.indexOf(action.areaId, 0);
      areas.areaIds.splice(remove_key, 1);
      areas.list.splice(remove_key, 1);
      setSumNums(areas);
      return { ...areas };

    case ActionTypes.SET_ROOT_AREA_ID:
      return { ...areas, rootAreaId: action.rootAreaId };

    case ActionTypes.CHANGE_AREA_NUM:
      const change_num_key = areas.areaIds.indexOf(action.areaId, 0);
      areas.list[change_num_key].num = action.num;
      areas.list[change_num_key].error = action.error;
      setSumNums(areas);
      return { ...areas };

    case ActionTypes.CHANGE_AREAS_HOUSE_TYPE:
      areas.list = action.list;
      setSumNums(areas);
      return { ...areas, houseTypeId: action.houseTypeId };

    case ActionTypes.ERROR_AREAS:
      const errors = areas.errors;
      const { key, msg } = action;
      return { ...areas, errors: { ...errors, [key]: msg } };

		case ActionTypes.RESET_AREAS_DIALOG:
				areas.openResetDialog = action.open;
				return { ...areas };
    default:
      return areas;
  }
}

export default areasReducer;



// WEBPACK FOOTER //
// ./src/reducers/areas.js